var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.phoneMask),expression:"phoneMask"}],attrs:{"placeholder":"(000) 000-00-00","value":_vm.value},on:{"input":_vm.handleInput}},'v-text-field',_vm.$attrs,false),{ ..._vm.$listeners, input: event => _vm.handleInput }))
}
var staticRenderFns = []

export { render, staticRenderFns }